export const PUBLIC = {
  HOME: "/",
};